import logo from "./logo.svg";
import "./App.css";
import { AiFillFacebook } from "react-icons/ai";
import { AiFillInstagram } from "react-icons/ai";
import { AiFillPhone } from "react-icons/ai";
import { IoLogoWhatsapp } from "react-icons/io";

function App() {
	return (
		<div className="App">
			<svg
				className="svg"
				width="501"
				height="334"
				viewBox="0 0 501 334"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M85.3111 302.497H50.5935C49.8419 302.497 49.2222 301.887 49.2222 301.118C49.2222 300.363 49.8287 299.74 50.5935 299.74H85.3111C86.0627 299.74 86.6824 300.35 86.6824 301.118C86.6824 301.887 86.0758 302.497 85.3111 302.497Z"
					fill="#4C2A76"
					fill-opacity="0.65"
				/>
				<path
					d="M366.823 181.479H365.834C365.834 180.658 365.161 179.982 364.344 179.982C363.526 179.982 362.854 180.658 362.854 181.479H361.865C361.865 180.101 362.973 178.988 364.344 178.988C365.702 178.988 366.823 180.101 366.823 181.479Z"
					fill="white"
				/>
				<path
					d="M370.37 123.443H369.381C369.381 122.621 368.708 121.945 367.891 121.945C367.073 121.945 366.401 122.621 366.401 123.443H365.412C365.412 122.064 366.519 120.951 367.891 120.951C369.249 120.951 370.37 122.077 370.37 123.443Z"
					fill="white"
				/>
				<path
					d="M246.939 325.107H199.748L200.553 323.198C203.651 315.816 203.968 309.508 203.493 302.285L203.401 300.827L243.182 300.707L243.195 302.073C243.234 306.738 244.487 317.327 246.372 323.318L246.939 325.107ZM203.823 322.35H243.247C241.731 316.585 240.703 308.249 240.492 303.451L206.302 303.557C206.631 309.958 206.249 315.79 203.823 322.35Z"
					fill="#4C2A76"
				/>
				<path
					d="M186.194 303.438C150.368 303.438 121.347 303.239 120.081 302.788C117.009 301.688 113.014 297.42 112.948 294.385C112.829 287.825 112.552 278.892 112.222 268.541C111.247 237.343 109.902 194.627 111.642 170.983C111.959 166.675 115.506 163.349 119.725 163.349C119.765 163.349 119.817 163.349 119.857 163.349L326.382 163.653C330.747 163.733 334.254 167.272 334.36 171.725C334.518 178.63 334.742 185.694 334.966 192.838C335.916 222.79 336.891 253.764 333.595 283.04C333.463 284.194 333.41 285.466 333.344 286.791C333.068 292.941 332.725 300.588 324.84 302.152C320.99 302.907 244.566 303.438 186.194 303.438ZM119.751 165.549C116.653 165.549 114.068 167.987 113.831 171.142C112.104 194.667 113.436 237.329 114.411 268.475C114.741 278.826 115.018 287.772 115.136 294.346C115.176 296.254 118.354 299.819 120.806 300.707C125.197 301.609 319.368 300.946 324.418 299.992C330.602 298.759 330.879 292.636 331.156 286.698C331.222 285.32 331.274 283.995 331.419 282.802C334.703 253.671 333.727 222.79 332.778 192.917C332.553 185.76 332.329 178.696 332.171 171.778C332.092 168.517 329.547 165.933 326.369 165.867L119.857 165.562C119.817 165.549 119.778 165.549 119.751 165.549Z"
					fill="#4C2A76"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M320.62 170.797L126.028 170.545C122.533 170.492 119.593 172.904 119.329 176.059C117.154 202.234 120.121 256.852 120.556 278.839C120.595 280.986 124.076 284.194 126.581 284.989C129.535 285.93 314.449 285.214 318.972 284.419C327.094 283.001 325.71 274.638 326.382 269.297C330.233 239.066 327.872 206.197 327.108 176.629C327.028 173.421 324.167 170.85 320.62 170.797Z"
					fill="#B99DDD"
					fill-opacity="0.65"
				/>
				<path
					d="M263.817 332.622H182.858C179.64 332.622 177.966 330.077 177.966 327.572C177.966 325.054 179.64 322.509 182.858 322.509H263.817C267.034 322.509 268.709 325.054 268.709 327.559C268.709 330.077 267.034 332.622 263.817 332.622ZM182.858 324.736C180.735 324.736 180.168 326.525 180.168 327.585C180.168 328.646 180.735 330.422 182.858 330.422H263.817C265.94 330.422 266.507 328.632 266.507 327.572C266.507 326.512 265.94 324.736 263.817 324.736H182.858Z"
					fill="#4C2A76"
				/>
				<path
					d="M126.463 295.737C130.102 295.737 130.102 290.052 126.463 290.052C122.837 290.052 122.824 295.737 126.463 295.737Z"
					fill="#4C2A76"
				/>
				<path
					d="M137.855 295.737C141.494 295.737 141.494 290.052 137.855 290.052C134.229 290.052 134.216 295.737 137.855 295.737Z"
					fill="#4C2A76"
				/>
				<path
					d="M149.247 295.737C152.887 295.737 152.887 290.052 149.247 290.052C145.621 290.052 145.608 295.737 149.247 295.737Z"
					fill="#4C2A76"
				/>
				<path
					d="M223.337 169.101C225.038 169.101 225.051 166.437 223.337 166.437C221.636 166.437 221.623 169.101 223.337 169.101Z"
					fill="#4C2A76"
				/>
				<path
					d="M158.596 95.5176L160.455 93.6489C160.838 93.2778 160.838 92.6549 160.455 92.2838L158.834 90.6668C158.464 90.2825 158.359 89.6066 158.623 89.1294L159.941 85.9221C160.086 85.4052 160.653 84.9944 161.181 84.9944H163.462C163.989 84.9944 164.424 84.557 164.424 84.0269V81.3894C164.424 80.8593 163.989 80.4219 163.462 80.4219H161.181C160.653 80.4219 160.099 79.9978 159.941 79.4942L158.623 76.2869C158.372 75.823 158.464 75.1338 158.834 74.7495L160.455 73.1325C160.838 72.7482 160.838 72.1385 160.455 71.7674L158.596 69.8987C158.227 69.5276 157.607 69.5276 157.238 69.8987L155.616 71.5289C155.234 71.9 154.561 72.006 154.1 71.7542L150.896 70.4288C150.382 70.283 149.973 69.7264 149.973 69.183V66.8902C149.973 66.36 149.538 65.9227 149.01 65.9227H146.386C145.859 65.9227 145.424 66.36 145.424 66.8902V69.183C145.424 69.7132 145.015 70.2698 144.501 70.4288L141.297 71.7542C140.835 72.006 140.15 71.9132 139.78 71.5289L138.159 69.912C137.789 69.5276 137.17 69.5276 136.8 69.912L134.941 71.7807C134.559 72.1518 134.559 72.7614 134.941 73.1458L136.55 74.7627C136.919 75.1471 137.025 75.8362 136.774 76.3001L135.456 79.5074C135.31 80.0243 134.743 80.4352 134.216 80.4352H131.922C131.394 80.4352 130.959 80.8593 130.959 81.4027V84.0401C130.959 84.5703 131.394 85.0076 131.922 85.0076H134.216C134.743 85.0076 135.297 85.4317 135.456 85.9354L136.774 89.1427C137.025 89.6066 136.932 90.2957 136.55 90.6801L134.941 92.297C134.559 92.6814 134.559 93.291 134.941 93.6621L136.8 95.5309C137.17 95.9152 137.776 95.9152 138.159 95.5309L139.78 93.9139C140.15 93.5428 140.835 93.4368 141.31 93.7019L144.501 95.0272C145.015 95.173 145.424 95.7297 145.424 96.273V98.5791C145.424 99.1093 145.859 99.5466 146.386 99.5466H149.01C149.538 99.5466 149.973 99.1093 149.973 98.5791V96.273C149.973 95.7429 150.382 95.1863 150.896 95.0272L154.1 93.7019C154.561 93.4501 155.247 93.5428 155.616 93.9139L157.238 95.5309C157.607 95.902 158.227 95.902 158.596 95.5176ZM147.705 90.415C143.472 90.415 140.031 86.9559 140.031 82.7015C140.031 78.4472 143.472 74.988 147.705 74.988C151.937 74.988 155.379 78.4339 155.379 82.7015C155.379 86.9559 151.937 90.415 147.705 90.415Z"
					fill="#B99DDD"
					fill-opacity="0.65"
				/>
				<path
					d="M176.344 102.807L175.869 101.243C175.777 100.925 175.434 100.753 175.131 100.845L173.773 101.256C173.456 101.349 173.047 101.203 172.876 100.925L171.518 99.2683C171.294 99.043 171.228 98.6057 171.373 98.3141L172.045 97.055C172.204 96.7634 172.085 96.3923 171.808 96.2465L170.371 95.4778C170.081 95.3188 169.725 95.4381 169.567 95.7297L168.894 96.9887C168.736 97.2803 168.353 97.4659 168.024 97.3996L165.888 97.1875C165.558 97.1875 165.215 96.9357 165.123 96.6176L164.714 95.2525C164.622 94.9345 164.292 94.7622 163.976 94.8549L162.42 95.3188C162.103 95.4116 161.932 95.7562 162.024 96.0742L162.433 97.4393C162.525 97.7574 162.38 98.155 162.103 98.3406L160.455 99.7057C160.231 99.9443 159.796 99.9973 159.506 99.8515L158.253 99.1756C157.963 99.0165 157.607 99.1225 157.449 99.4274L156.671 100.859C156.526 101.15 156.631 101.521 156.908 101.667L158.161 102.343C158.451 102.502 158.636 102.887 158.57 103.205L158.359 105.352C158.359 105.683 158.108 106.028 157.792 106.12L156.434 106.531C156.117 106.624 155.933 106.969 156.038 107.273L156.513 108.837C156.605 109.155 156.935 109.328 157.251 109.235L158.609 108.824C158.926 108.731 159.321 108.877 159.506 109.155L160.864 110.825C161.101 111.051 161.154 111.488 161.009 111.78L160.337 113.039C160.178 113.33 160.297 113.688 160.587 113.847L162.024 114.616C162.314 114.775 162.67 114.656 162.829 114.377L163.501 113.118C163.646 112.827 164.042 112.641 164.358 112.707L166.481 112.919C166.811 112.919 167.154 113.171 167.259 113.489L167.668 114.854C167.76 115.172 168.103 115.358 168.406 115.252L169.962 114.775C170.279 114.682 170.45 114.337 170.371 114.033L169.962 112.668C169.87 112.349 170.015 111.939 170.292 111.766L171.953 110.401C172.177 110.163 172.612 110.096 172.902 110.255L174.155 110.931C174.445 111.09 174.814 110.984 174.959 110.693L175.724 109.248C175.882 108.957 175.764 108.599 175.474 108.44L174.221 107.764C173.931 107.605 173.746 107.22 173.812 106.902L174.023 104.755C174.023 104.424 174.274 104.079 174.59 103.987L175.948 103.576C176.252 103.456 176.436 103.125 176.344 102.807ZM170.384 107.3C169.145 109.633 166.257 110.507 163.949 109.261C161.629 108.016 160.759 105.113 161.998 102.794C163.237 100.461 166.125 99.5864 168.433 100.832C170.74 102.078 171.623 104.967 170.384 107.3Z"
					fill="#B99DDD"
					fill-opacity="0.65"
				/>
				<path
					d="M253.98 132.998H210.995C210.244 132.998 209.624 132.389 209.624 131.62C209.624 130.864 210.231 130.242 210.995 130.242H253.98C254.732 130.242 255.352 130.851 255.352 131.62C255.352 132.389 254.745 132.998 253.98 132.998Z"
					fill="#4C2A76"
					fill-opacity="0.65"
				/>
				<path
					d="M166.481 152.627H97.0456C96.294 152.627 95.6743 152.017 95.6743 151.248C95.6743 150.48 96.2809 149.87 97.0456 149.87H166.481C167.232 149.87 167.852 150.48 167.852 151.248C167.852 152.017 167.232 152.627 166.481 152.627Z"
					fill="#4C2A76"
					fill-opacity="0.65"
				/>
				<path
					d="M480.774 189.789H429.582C429.027 189.789 428.571 189.18 428.571 188.411C428.571 187.642 429.018 187.033 429.582 187.033H480.774C481.329 187.033 481.785 187.642 481.785 188.411C481.785 189.18 481.338 189.789 480.774 189.789Z"
					fill="#4C2A76"
					fill-opacity="0.65"
				/>
				<path
					d="M499.699 334H1.30104C0.587969 334 0 333.39 0 332.622C0 331.866 0.575459 331.243 1.30104 331.243H499.699C500.412 331.243 501 331.853 501 332.622C500.987 333.39 500.412 334 499.699 334Z"
					fill="#4C2A76"
					fill-opacity="0.65"
				/>
				<path
					d="M333.991 115.742C331.05 115.742 328.281 116.895 326.198 118.989C322.651 122.555 321.939 128.095 324.484 132.442L324.668 132.746L313.5 143.972C313.487 143.985 312.96 144.502 312.946 145.244C312.946 145.814 313.223 146.384 313.79 146.954C314.397 147.551 315.017 147.855 315.663 147.855C316.427 147.855 316.968 147.405 316.981 147.405L328.123 136.206L328.426 136.391C330.114 137.385 332.039 137.915 334.004 137.915C336.944 137.915 339.713 136.762 341.796 134.668C346.095 130.348 346.095 123.31 341.796 118.989C339.7 116.895 336.931 115.742 333.991 115.742ZM333.991 134.615C329.718 134.615 326.237 131.116 326.237 126.822C326.237 122.528 329.718 119.029 333.991 119.029C338.263 119.029 341.744 122.528 341.744 126.822C341.744 131.116 338.263 134.615 333.991 134.615Z"
					fill="#B99DDD"
					fill-opacity="0.65"
				/>
				<path
					d="M329.903 128.439H337.893V126.385H329.903V128.439Z"
					fill="#B99DDD"
					fill-opacity="0.65"
				/>
				<path
					d="M129.192 331.455C128.441 331.455 127.821 330.846 127.821 330.077V224.222C127.821 223.466 128.427 222.843 129.192 222.843C129.944 222.843 130.563 223.453 130.563 224.222V330.077C130.563 330.846 129.957 331.455 129.192 331.455Z"
					fill="#4C2A76"
					fill-opacity="0.65"
				/>
				<path
					d="M153.678 331.455C152.926 331.455 152.306 330.846 152.306 330.077V224.222C152.306 223.466 152.913 222.843 153.678 222.843C154.442 222.843 155.049 223.453 155.049 224.222V330.077C155.036 330.846 154.429 331.455 153.678 331.455Z"
					fill="#4C2A76"
					fill-opacity="0.65"
				/>
				<path
					d="M153.678 232.823H129.192C128.441 232.823 127.821 232.214 127.821 231.445C127.821 230.69 128.427 230.067 129.192 230.067H153.665C154.416 230.067 155.036 230.676 155.036 231.445C155.036 232.214 154.429 232.823 153.678 232.823Z"
					fill="#4C2A76"
					fill-opacity="0.65"
				/>
				<path
					d="M153.678 244.924H129.192C128.441 244.924 127.821 244.314 127.821 243.545C127.821 242.79 128.427 242.167 129.192 242.167H153.665C154.416 242.167 155.036 242.777 155.036 243.545C155.036 244.314 154.429 244.924 153.678 244.924Z"
					fill="#4C2A76"
					fill-opacity="0.65"
				/>
				<path
					d="M153.678 257.024H129.192C128.441 257.024 127.821 256.414 127.821 255.646C127.821 254.89 128.427 254.267 129.192 254.267H153.665C154.416 254.267 155.036 254.877 155.036 255.646C155.036 256.401 154.429 257.024 153.678 257.024Z"
					fill="#4C2A76"
					fill-opacity="0.65"
				/>
				<path
					d="M153.678 269.111H129.192C128.441 269.111 127.821 268.502 127.821 267.733C127.821 266.977 128.427 266.354 129.192 266.354H153.665C154.416 266.354 155.036 266.964 155.036 267.733C155.036 268.502 154.429 269.111 153.678 269.111Z"
					fill="#4C2A76"
					fill-opacity="0.65"
				/>
				<path
					d="M153.678 281.212H129.192C128.441 281.212 127.821 280.602 127.821 279.833C127.821 279.078 128.427 278.455 129.192 278.455H153.665C154.416 278.455 155.036 279.064 155.036 279.833C155.036 280.589 154.429 281.212 153.678 281.212Z"
					fill="#4C2A76"
					fill-opacity="0.65"
				/>
				<path
					d="M153.678 293.299H129.192C128.441 293.299 127.821 292.689 127.821 291.92C127.821 291.152 128.427 290.542 129.192 290.542H153.665C154.416 290.542 155.036 291.152 155.036 291.92C155.036 292.689 154.429 293.299 153.678 293.299Z"
					fill="#4C2A76"
					fill-opacity="0.65"
				/>
				<path
					d="M153.678 305.399H129.192C128.441 305.399 127.821 304.79 127.821 304.021C127.821 303.265 128.427 302.642 129.192 302.642H153.665C154.416 302.642 155.036 303.252 155.036 304.021C155.036 304.776 154.429 305.399 153.678 305.399Z"
					fill="#4C2A76"
					fill-opacity="0.65"
				/>
				<path
					d="M153.678 317.486H129.192C128.441 317.486 127.821 316.877 127.821 316.108C127.821 315.352 128.427 314.729 129.192 314.729H153.665C154.416 314.729 155.036 315.339 155.036 316.108C155.036 316.877 154.429 317.486 153.678 317.486Z"
					fill="#4C2A76"
					fill-opacity="0.65"
				/>
				<path
					d="M95.8723 229.351C95.1207 229.351 94.501 228.741 94.501 227.972V222.618C94.501 221.863 95.1075 221.24 95.8723 221.24C96.6239 221.24 97.2436 221.849 97.2436 222.618V227.972C97.2304 228.741 96.6239 229.351 95.8723 229.351Z"
					fill="#4C2A76"
					fill-opacity="0.65"
				/>
				<path
					d="M98.5225 226.674H93.1955C92.4439 226.674 91.8242 226.064 91.8242 225.295C91.8242 224.54 92.4308 223.917 93.1955 223.917H98.5225C99.2741 223.917 99.8938 224.527 99.8938 225.295C99.8938 226.064 99.2873 226.674 98.5225 226.674Z"
					fill="#4C2A76"
					fill-opacity="0.65"
				/>
				<path
					d="M218.841 37.9314C218.089 37.9314 217.47 37.3217 217.47 36.553V31.1986C217.47 30.4432 218.076 29.8203 218.841 29.8203C219.593 29.8203 220.212 30.4299 220.212 31.1986V36.553C220.212 37.3084 219.593 37.9314 218.841 37.9314Z"
					fill="#4C2A76"
					fill-opacity="0.65"
				/>
				<path
					d="M221.504 35.2542H216.177C215.426 35.2542 214.806 34.6445 214.806 33.8758C214.806 33.1071 215.413 32.4974 216.177 32.4974H221.504C222.256 32.4974 222.876 33.1071 222.876 33.8758C222.876 34.6445 222.256 35.2542 221.504 35.2542Z"
					fill="#4C2A76"
					fill-opacity="0.65"
				/>
				<path
					d="M261.958 315.008C261.839 315.008 261.707 314.995 261.575 314.955L256.459 313.484C255.734 313.272 255.312 312.516 255.523 311.787C255.734 311.058 256.486 310.647 257.211 310.846L262.327 312.317C263.052 312.529 263.474 313.285 263.263 314.014C263.092 314.623 262.551 315.008 261.958 315.008Z"
					fill="#4C2A76"
					fill-opacity="0.65"
				/>
				<path
					d="M258.662 316.85C258.543 316.85 258.411 316.837 258.279 316.797C257.554 316.585 257.132 315.83 257.343 315.101L258.807 309.958C259.018 309.229 259.769 308.819 260.494 309.017C261.22 309.229 261.642 309.985 261.431 310.714L259.967 315.856C259.809 316.453 259.255 316.85 258.662 316.85Z"
					fill="#4C2A76"
					fill-opacity="0.65"
				/>
				<path
					d="M235.059 153.369C234.941 153.369 234.809 153.356 234.677 153.316L229.561 151.845C228.836 151.633 228.414 150.877 228.625 150.148C228.836 149.419 229.587 148.995 230.312 149.207L235.428 150.678C236.154 150.89 236.576 151.646 236.365 152.375C236.193 152.971 235.653 153.369 235.059 153.369Z"
					fill="#4C2A76"
					fill-opacity="0.65"
				/>
				<path
					d="M231.763 155.198C231.644 155.198 231.512 155.185 231.381 155.145C230.655 154.933 230.233 154.177 230.444 153.448L231.908 148.306C232.119 147.577 232.871 147.153 233.596 147.365C234.321 147.577 234.743 148.333 234.532 149.061L233.068 154.204C232.91 154.813 232.356 155.198 231.763 155.198Z"
					fill="#4C2A76"
					fill-opacity="0.65"
				/>
				<path
					d="M244.908 116.214C252.328 108.756 252.328 96.6639 244.908 89.2056C237.488 81.7474 225.458 81.7474 218.038 89.2056C210.618 96.6639 210.618 108.756 218.038 116.214C225.458 123.673 237.488 123.673 244.908 116.214Z"
					fill="#B99DDD"
					fill-opacity="0.65"
				/>
				<path
					d="M231.473 117.015C239.33 117.015 245.7 110.612 245.7 102.714C245.7 94.8162 239.33 88.4137 231.473 88.4137C223.615 88.4137 217.246 94.8162 217.246 102.714C217.246 110.612 223.615 117.015 231.473 117.015Z"
					fill="white"
				/>
				<path
					d="M231.473 117.571C223.324 117.571 216.692 110.905 216.692 102.714C216.692 94.5235 223.324 87.8571 231.473 87.8571C239.621 87.8571 246.254 94.5235 246.254 102.714C246.254 110.905 239.621 117.571 231.473 117.571ZM231.473 88.9571C223.931 88.9571 217.799 95.1199 217.799 102.714C217.799 110.295 223.931 116.458 231.473 116.458C239.015 116.458 245.146 110.295 245.146 102.714C245.146 95.1332 239.015 88.9571 231.473 88.9571Z"
					fill="#4C2A76"
					fill-opacity="0.65"
				/>
				<path
					d="M231.473 103.258C231.169 103.258 230.919 103.006 230.919 102.701V95.4248C230.919 95.12 231.169 94.8682 231.473 94.8682C231.776 94.8682 232.026 95.12 232.026 95.4248V102.701C232.013 103.019 231.776 103.258 231.473 103.258Z"
					fill="#4C2A76"
					fill-opacity="0.65"
				/>
				<path
					d="M239.951 103.258H231.459C231.156 103.258 230.906 103.006 230.906 102.701C230.906 102.396 231.156 102.144 231.459 102.144H239.951C240.254 102.144 240.505 102.396 240.505 102.701C240.505 103.019 240.254 103.258 239.951 103.258Z"
					fill="#4C2A76"
					fill-opacity="0.65"
				/>
				<path
					d="M232.027 90.0174C232.027 90.3355 231.776 90.5873 231.46 90.5873C231.143 90.5873 230.893 90.3355 230.893 90.0174C230.893 89.6993 231.143 89.4475 231.46 89.4475C231.776 89.4475 232.027 89.7126 232.027 90.0174Z"
					fill="#4C2A76"
					fill-opacity="0.65"
				/>
				<path
					d="M240.4 94.3115C240.713 94.3115 240.966 94.0563 240.966 93.7416C240.966 93.4268 240.713 93.1717 240.4 93.1717C240.086 93.1717 239.833 93.4268 239.833 93.7416C239.833 94.0563 240.086 94.3115 240.4 94.3115Z"
					fill="#4C2A76"
					fill-opacity="0.65"
				/>
				<path
					d="M244.092 103.271C243.775 103.271 243.525 103.019 243.525 102.701C243.525 102.383 243.775 102.131 244.092 102.131C244.408 102.131 244.658 102.383 244.658 102.701C244.658 103.019 244.408 103.271 244.092 103.271Z"
					fill="#4C2A76"
					fill-opacity="0.65"
				/>
				<path
					d="M240.4 112.257C240.713 112.257 240.966 112.002 240.966 111.687C240.966 111.372 240.713 111.117 240.4 111.117C240.086 111.117 239.833 111.372 239.833 111.687C239.833 112.002 240.086 112.257 240.4 112.257Z"
					fill="#4C2A76"
					fill-opacity="0.65"
				/>
				<path
					d="M230.906 115.398C230.906 115.08 231.156 114.828 231.473 114.828C231.789 114.828 232.04 115.08 232.04 115.398C232.04 115.716 231.789 115.968 231.473 115.968C231.156 115.968 230.906 115.716 230.906 115.398Z"
					fill="#4C2A76"
					fill-opacity="0.65"
				/>
				<path
					d="M222.151 111.276C222.375 111.051 222.731 111.051 222.942 111.276C223.166 111.501 223.166 111.859 222.942 112.071C222.718 112.296 222.362 112.296 222.151 112.071C221.926 111.859 221.926 111.501 222.151 111.276Z"
					fill="#4C2A76"
					fill-opacity="0.65"
				/>
				<path
					d="M218.841 103.284C219.154 103.284 219.408 103.029 219.408 102.714C219.408 102.399 219.154 102.144 218.841 102.144C218.528 102.144 218.274 102.399 218.274 102.714C218.274 103.029 218.528 103.284 218.841 103.284Z"
					fill="#4C2A76"
					fill-opacity="0.65"
				/>
				<path
					d="M222.942 93.3307C223.166 93.556 223.166 93.9139 222.942 94.1259C222.718 94.3512 222.362 94.3512 222.151 94.1259C221.926 93.9006 221.926 93.5428 222.151 93.3307C222.362 93.1187 222.718 93.1187 222.942 93.3307Z"
					fill="#4C2A76"
					fill-opacity="0.65"
				/>
				<path
					d="M259.255 95.4116H251.278C250.974 95.4116 250.724 95.1598 250.724 94.8549C250.724 94.5501 250.974 94.2983 251.278 94.2983H259.255C259.558 94.2983 259.809 94.5501 259.809 94.8549C259.809 95.173 259.558 95.4116 259.255 95.4116Z"
					fill="#4C2A76"
					fill-opacity="0.65"
				/>
				<path
					d="M259.255 111.104H251.277C250.974 111.104 250.724 110.852 250.724 110.547C250.724 110.242 250.974 109.99 251.277 109.99H259.255C259.558 109.99 259.808 110.242 259.808 110.547C259.808 110.865 259.558 111.104 259.255 111.104Z"
					fill="#4C2A76"
					fill-opacity="0.65"
				/>
				<path
					d="M269.17 103.271H254.271C253.967 103.271 253.717 103.019 253.717 102.714C253.717 102.409 253.967 102.158 254.271 102.158H269.17C269.474 102.158 269.724 102.409 269.724 102.714C269.724 103.019 269.474 103.271 269.17 103.271Z"
					fill="#4C2A76"
					fill-opacity="0.65"
				/>
				<path
					d="M295.159 309.521H286.351V318.374H295.159V309.521Z"
					fill="white"
				/>
				<path
					d="M295.858 319.063H285.678V308.832H295.858V319.063ZM287.037 317.685H294.486V310.197H287.037V317.685Z"
					fill="#4C2A76"
				/>
				<path
					d="M306.314 311.469H298.337C298.034 311.469 297.783 311.217 297.783 310.912C297.783 310.608 298.034 310.356 298.337 310.356H306.314C306.617 310.356 306.868 310.608 306.868 310.912C306.868 311.217 306.617 311.469 306.314 311.469Z"
					fill="#4C2A76"
					fill-opacity="0.65"
				/>
				<path
					d="M309.321 317.526H298.535C298.126 317.526 297.796 317.274 297.796 316.969C297.796 316.665 298.126 316.413 298.535 316.413H309.321C309.729 316.413 310.059 316.665 310.059 316.969C310.059 317.287 309.729 317.526 309.321 317.526Z"
					fill="#4C2A76"
					fill-opacity="0.65"
				/>
				<path
					d="M313.237 314.332H298.337C298.034 314.332 297.783 314.08 297.783 313.775C297.783 313.47 298.034 313.219 298.337 313.219H313.237C313.54 313.219 313.79 313.47 313.79 313.775C313.79 314.08 313.54 314.332 313.237 314.332Z"
					fill="#4C2A76"
					fill-opacity="0.65"
				/>
				<path
					d="M92.8971 188.417H101.705V179.564H92.8971V188.417Z"
					fill="white"
				/>
				<path
					d="M102.386 189.1H92.2068V178.868H102.386V189.1ZM93.5781 187.722H101.015V180.247H93.5781V187.722Z"
					fill="#4C2A76"
				/>
				<path
					d="M81.7374 181.506H89.7147C90.0179 181.506 90.2685 181.254 90.2685 180.949C90.2685 180.644 90.0179 180.393 89.7147 180.393H81.7374C81.4341 180.393 81.1836 180.644 81.1836 180.949C81.1968 181.254 81.4341 181.506 81.7374 181.506Z"
					fill="#4C2A76"
					fill-opacity="0.65"
				/>
				<path
					d="M78.7445 187.576H89.5303C89.939 187.576 90.2687 187.324 90.2687 187.019C90.2687 186.715 89.939 186.463 89.5303 186.463H78.7445C78.3357 186.463 78.0061 186.715 78.0061 187.019C78.0061 187.324 78.3357 187.576 78.7445 187.576Z"
					fill="#4C2A76"
					fill-opacity="0.65"
				/>
				<path
					d="M74.8148 184.369H89.7145C90.0177 184.369 90.2683 184.117 90.2683 183.812C90.2683 183.507 90.0177 183.255 89.7145 183.255H74.8148C74.5115 183.255 74.261 183.507 74.261 183.812C74.2742 184.117 74.5115 184.369 74.8148 184.369Z"
					fill="#4C2A76"
					fill-opacity="0.65"
				/>
				<path
					d="M364.331 212.837H361.601V331.045H364.331V212.837Z"
					fill="#3F5B91"
				/>
				<path
					d="M363.276 227.138H362.669C358.213 227.138 354.56 223.466 354.56 218.987V208.066C354.56 203.586 358.213 199.915 362.669 199.915H363.276C367.733 199.915 371.385 203.586 371.385 208.066V218.987C371.385 223.466 367.733 227.138 363.276 227.138Z"
					fill="#B99DDD"
					fill-opacity="0.65"
				/>
				<path
					d="M373.982 219.225C374.945 219.384 375.908 219.53 376.87 219.689C377.516 219.795 377.793 218.801 377.147 218.695C376.184 218.536 375.222 218.39 374.259 218.231C373.613 218.139 373.336 219.119 373.982 219.225Z"
					fill="#3F5B91"
				/>
				<path
					d="M373.89 212.93C374.642 212.797 375.393 212.784 376.158 212.85C376.817 212.917 376.804 211.883 376.158 211.817C375.301 211.737 374.47 211.777 373.613 211.936C372.967 212.055 373.244 213.049 373.89 212.93Z"
					fill="#3F5B91"
				/>
				<path
					d="M373.574 207.191C374.312 206.9 375.05 206.608 375.789 206.303C376.395 206.065 376.132 205.071 375.512 205.309C374.774 205.601 374.035 205.892 373.297 206.197C372.69 206.436 372.954 207.443 373.574 207.191Z"
					fill="#3F5B91"
				/>
				<path
					d="M348.429 220.193C349.18 220.087 349.919 219.914 350.644 219.663C351.264 219.451 351 218.457 350.367 218.669C349.642 218.92 348.917 219.093 348.152 219.199C347.506 219.291 347.783 220.285 348.429 220.193Z"
					fill="#3F5B91"
				/>
				<path
					d="M347.097 212.864C348.046 212.89 348.969 213.036 349.879 213.288C350.512 213.473 350.789 212.479 350.156 212.294C349.154 212.015 348.139 211.856 347.097 211.83C346.438 211.817 346.438 212.85 347.097 212.864Z"
					fill="#3F5B91"
				/>
				<path
					d="M347.994 204.381C348.732 204.62 349.47 204.859 350.209 205.097C350.842 205.296 351.105 204.302 350.486 204.103C349.747 203.865 349.009 203.626 348.27 203.387C347.638 203.189 347.361 204.183 347.994 204.381Z"
					fill="#3F5B91"
				/>
				<path
					d="M356.591 332.648L358.41 316.85H367.297L369.354 332.423L356.591 332.648Z"
					fill="#4C2A76"
					fill-opacity="0.65"
				/>
				<path
					d="M184.268 237.608C195.305 227.575 206.341 217.542 217.377 207.522C219.012 206.038 216.586 203.613 214.964 205.097C203.928 215.13 192.892 225.163 181.855 235.182C180.207 236.667 182.633 239.092 184.268 237.608Z"
					fill="#D7E7FF"
				/>
				<path
					d="M221.689 252.955C232.725 242.922 243.762 232.889 254.798 222.87C256.433 221.385 254.007 218.96 252.385 220.444C241.349 230.477 230.312 240.51 219.276 250.53C217.628 252.014 220.054 254.44 221.689 252.955Z"
					fill="#D7E7FF"
				/>
				<path
					d="M181.025 264.327C204.165 241.65 227.293 218.973 250.433 196.297C252.016 194.746 249.59 192.321 248.021 193.871C224.88 216.548 201.752 239.225 178.612 261.901C177.029 263.452 179.442 265.877 181.025 264.327Z"
					fill="#D7E7FF"
				/>
				<path
					d="M287.103 52.8017H285.613V148.81H287.103V52.8017Z"
					fill="#4C2A76"
				/>
				<path
					d="M292.417 148.796C292.417 152.163 289.7 154.893 286.351 154.893C283.002 154.893 280.286 152.163 280.286 148.796C280.286 145.43 283.002 142.7 286.351 142.7C289.7 142.713 292.417 145.43 292.417 148.796Z"
					fill="#4C2A76"
				/>
				<path
					d="M286.443 169.246C286.338 169.246 284.36 169.233 282.923 167.775C281.96 166.808 281.472 165.469 281.472 163.786C281.472 163.335 281.828 162.978 282.277 162.978C282.725 162.978 283.081 163.335 283.081 163.786C283.081 165.019 283.411 165.986 284.057 166.636C285.033 167.603 286.43 167.63 286.443 167.63C288.711 167.63 290.544 165.774 290.544 163.508C290.544 161.228 288.698 159.386 286.443 159.386C285.995 159.386 285.639 159.028 285.639 158.577V154.098C285.639 153.647 285.995 153.289 286.443 153.289C286.892 153.289 287.248 153.647 287.248 154.098V157.822C290.017 158.22 292.153 160.618 292.153 163.508C292.153 166.675 289.595 169.246 286.443 169.246Z"
					fill="#4C2A76"
				/>
				<path
					d="M254.6 172.997C254.297 172.944 254.033 172.692 253.994 172.374C253.928 171.963 254.218 171.592 254.627 171.526L287.446 166.662C287.854 166.596 288.237 166.887 288.29 167.298C288.355 167.709 288.065 168.08 287.657 168.146L254.838 173.01C254.759 173.01 254.679 173.01 254.6 172.997Z"
					fill="#4C2A76"
				/>
				<path
					d="M317.601 183.971C317.522 183.958 317.456 183.931 317.39 183.891L287.208 168.054C286.839 167.868 286.707 167.404 286.892 167.046C287.076 166.675 287.525 166.543 287.894 166.728L318.076 182.566C318.445 182.752 318.577 183.216 318.392 183.573C318.234 183.878 317.904 184.024 317.601 183.971Z"
					fill="#4C2A76"
				/>
				<path
					d="M315.135 247.296L234.769 233.261C230.563 232.532 227.741 228.503 228.467 224.261L236.51 177.742C237.235 173.514 241.243 170.678 245.463 171.407L325.842 185.442C330.048 186.171 332.87 190.2 332.145 194.441L324.101 240.961C323.35 245.202 319.342 248.038 315.135 247.296Z"
					fill="white"
				/>
				<path
					d="M316.23 248.409C315.715 248.409 315.201 248.37 314.674 248.277L234.861 234.334C232.475 233.923 230.405 232.598 229.007 230.61C227.609 228.622 227.082 226.21 227.491 223.811L235.428 177.861C236.286 172.918 240.98 169.591 245.898 170.453L325.71 184.395C328.097 184.806 330.167 186.131 331.564 188.119C332.962 190.107 333.49 192.52 333.081 194.918L325.143 240.868C324.378 245.281 320.555 248.396 316.23 248.409ZM244.355 172.374C241.019 172.374 238.052 174.786 237.459 178.206L229.521 224.156C229.205 226.011 229.614 227.88 230.695 229.404C231.776 230.941 233.385 231.962 235.217 232.293L315.03 246.236C318.827 246.912 322.466 244.327 323.126 240.51L331.063 194.561C331.38 192.705 330.971 190.836 329.89 189.299C328.809 187.762 327.2 186.741 325.367 186.423L245.555 172.48C245.159 172.414 244.751 172.374 244.355 172.374Z"
					fill="#4C2A76"
				/>
				<path
					d="M314.529 242.26L237.011 228.728C234.321 228.264 232.514 225.68 232.989 222.976L240.333 180.499C240.795 177.795 243.366 175.979 246.056 176.456L323.574 189.988C326.264 190.452 328.07 193.036 327.596 195.74L320.251 238.217C319.79 240.921 317.219 242.737 314.529 242.26Z"
					fill="#B99DDD"
					fill-opacity="0.65"
				/>
				<path
					d="M315.241 243.346C314.885 243.346 314.529 243.32 314.173 243.254L237.024 229.775C235.402 229.497 233.991 228.595 233.042 227.244C232.093 225.892 231.723 224.248 232.014 222.618L239.292 180.499C239.872 177.146 243.063 174.879 246.412 175.462L323.561 188.941C326.91 189.524 329.152 192.732 328.572 196.098L321.293 238.217C321.016 239.848 320.12 241.266 318.775 242.22C317.72 242.949 316.494 243.346 315.241 243.346ZM314.529 241.213C315.61 241.398 316.691 241.16 317.588 240.523C318.485 239.887 319.078 238.946 319.262 237.86L326.541 195.74C326.923 193.5 325.433 191.366 323.205 190.969L246.056 177.49C243.828 177.106 241.705 178.603 241.309 180.843L234.031 222.963C233.846 224.049 234.084 225.136 234.717 226.037C235.35 226.939 236.286 227.535 237.367 227.721L314.529 241.213Z"
					fill="#4C2A76"
					fill-opacity="0.65"
				/>
				<path
					d="M277.767 235.845L297.823 217.37L308.925 241.279L277.767 235.845Z"
					fill="white"
				/>
				<path
					d="M310.098 242.18L276.277 236.269L298.047 216.217L310.098 242.18ZM279.244 235.408L307.738 240.391L297.585 218.509L279.244 235.408Z"
					fill="#4C2A76"
				/>
				<path
					d="M238.105 228.913L273.666 196.164L293.339 238.562L238.105 228.913Z"
					fill="white"
				/>
				<path
					d="M294.513 239.463L236.615 229.351L273.891 195.011L294.513 239.463ZM239.595 228.476L292.166 237.661L273.429 197.304L239.595 228.476Z"
					fill="#4C2A76"
				/>
				<path
					d="M315.939 202.367C315.465 205.084 312.894 206.913 310.191 206.436C307.487 205.959 305.668 203.374 306.143 200.657C306.617 197.94 309.188 196.111 311.891 196.588C314.608 197.066 316.414 199.65 315.939 202.367Z"
					fill="white"
				/>
				<path
					d="M311.061 207.204C310.731 207.204 310.402 207.178 310.085 207.125C307.013 206.581 304.943 203.639 305.483 200.551C305.747 199.054 306.565 197.755 307.804 196.88C309.044 196.005 310.534 195.661 312.023 195.926C313.513 196.191 314.806 197.012 315.676 198.258C316.546 199.504 316.876 201.002 316.625 202.499C316.362 203.997 315.544 205.296 314.305 206.171C313.342 206.847 312.208 207.204 311.061 207.204ZM311.035 197.198C310.164 197.198 309.307 197.463 308.569 197.98C307.633 198.643 307.013 199.637 306.815 200.763C306.617 201.903 306.881 203.043 307.527 203.984C308.186 204.925 309.175 205.548 310.296 205.747C311.417 205.945 312.564 205.693 313.5 205.031C314.436 204.368 315.056 203.374 315.254 202.248C315.663 199.902 314.094 197.675 311.76 197.264C311.536 197.225 311.285 197.198 311.035 197.198Z"
					fill="#4C2A76"
				/>
				<path
					d="M347.849 49.5679H273.311V57.8115H347.849V49.5679Z"
					fill="#B99DDD"
					fill-opacity="0.65"
				/>
				<path
					d="M412.616 220.007H387.867V0.106018H412.616V220.007ZM390.32 217.555H410.164V2.57116H390.32V217.555Z"
					fill="#4C2A76"
				/>
				<path
					d="M412.3 24.2405H388.17V0H412.3V24.2405ZM390.662 21.7489H409.821V2.49165H390.662V21.7489Z"
					fill="#4C2A76"
				/>
				<path
					d="M390.297 0.362664L388.545 2.12451L410.184 23.8758L411.937 22.1139L390.297 0.362664Z"
					fill="#4C2A76"
				/>
				<path
					d="M410.185 0.373006L388.545 22.1243L390.298 23.8861L411.938 2.13485L410.185 0.373006Z"
					fill="#4C2A76"
				/>
				<path
					d="M412.3 46.0027H388.17V21.7489H412.3V46.0027ZM390.662 43.5111H409.821V24.2406H390.662V43.5111Z"
					fill="#4C2A76"
				/>
				<path
					d="M390.294 22.1139L388.541 23.8758L410.181 45.6271L411.934 43.8652L390.294 22.1139Z"
					fill="#4C2A76"
				/>
				<path
					d="M410.181 22.1234L388.541 43.8746L390.294 45.6365L411.934 23.8852L410.181 22.1234Z"
					fill="#4C2A76"
				/>
				<path
					d="M412.3 67.7516H388.17V43.4978H412.3V67.7516ZM390.662 65.26H409.821V46.0027H390.662V65.26Z"
					fill="#4C2A76"
				/>
				<path
					d="M390.298 43.8719L388.545 45.6337L410.185 67.385L411.938 65.6231L390.298 43.8719Z"
					fill="#4C2A76"
				/>
				<path
					d="M410.195 43.8955L388.556 65.6467L390.308 67.4086L411.948 45.6573L410.195 43.8955Z"
					fill="#4C2A76"
				/>
				<path
					d="M412.3 89.5137H388.17V65.2599H412.3V89.5137ZM390.662 87.0221H409.821V67.7516H390.662V87.0221Z"
					fill="#4C2A76"
				/>
				<path
					d="M390.294 65.6232L388.542 67.385L410.182 89.1363L411.934 87.3744L390.294 65.6232Z"
					fill="#4C2A76"
				/>
				<path
					d="M410.182 65.6336L388.542 87.3849L390.295 89.1467L411.935 67.3955L410.182 65.6336Z"
					fill="#4C2A76"
				/>
				<path
					d="M412.3 111.263H388.17V87.0221H412.3V111.263ZM390.662 108.771H409.821V89.5137H390.662V108.771Z"
					fill="#4C2A76"
				/>
				<path
					d="M390.3 87.3841L388.547 89.1459L410.187 110.897L411.94 109.135L390.3 87.3841Z"
					fill="#4C2A76"
				/>
				<path
					d="M410.186 87.3974L388.546 109.149L390.299 110.91L411.939 89.1592L410.186 87.3974Z"
					fill="#4C2A76"
				/>
				<path
					d="M412.3 133.025H388.17V108.771H412.3V133.025ZM390.662 130.533H409.821V111.263H390.662V130.533Z"
					fill="#4C2A76"
				/>
				<path
					d="M390.295 109.132L388.542 110.894L410.182 132.645L411.935 130.883L390.295 109.132Z"
					fill="#4C2A76"
				/>
				<path
					d="M410.191 109.158L388.551 130.909L390.303 132.671L411.943 110.92L410.191 109.158Z"
					fill="#4C2A76"
				/>
				<path
					d="M412.3 154.774H388.17V130.533H412.3V154.774ZM390.662 152.282H409.821V133.025H390.662V152.282Z"
					fill="#4C2A76"
				/>
				<path
					d="M390.301 130.894L388.548 132.656L410.188 154.407L411.941 152.645L390.301 130.894Z"
					fill="#4C2A76"
				/>
				<path
					d="M410.186 130.909L388.546 152.66L390.299 154.422L411.939 132.671L410.186 130.909Z"
					fill="#4C2A76"
				/>
				<path
					d="M412.3 176.523H388.17V152.282H412.3V176.523ZM390.662 174.031H409.821V154.774H390.662V174.031Z"
					fill="#4C2A76"
				/>
				<path
					d="M390.297 152.643L388.544 154.405L410.184 176.157L411.937 174.395L390.297 152.643Z"
					fill="#4C2A76"
				/>
				<path
					d="M410.191 152.669L388.551 174.42L390.303 176.182L411.943 154.431L410.191 152.669Z"
					fill="#4C2A76"
				/>
				<path
					d="M412.3 198.285H388.17V174.044H412.3V198.285ZM390.662 195.793H409.821V176.536H390.662V195.793Z"
					fill="#4C2A76"
				/>
				<path
					d="M390.293 174.395L388.54 176.157L410.18 197.908L411.933 196.146L390.293 174.395Z"
					fill="#4C2A76"
				/>
				<path
					d="M410.186 174.42L388.546 196.171L390.299 197.933L411.939 176.182L410.186 174.42Z"
					fill="#4C2A76"
				/>
				<path
					d="M412.3 220.034H388.17V195.793H412.3V220.034ZM390.662 217.542H409.821V198.285H390.662V217.542Z"
					fill="#4C2A76"
				/>
				<path
					d="M390.297 196.151L388.544 197.913L410.184 219.664L411.937 217.902L390.297 196.151Z"
					fill="#4C2A76"
				/>
				<path
					d="M410.181 196.146L388.538 217.894L390.29 219.656L411.933 197.908L410.181 196.146Z"
					fill="#4C2A76"
				/>
				<path
					d="M455.364 45.6714H431.247V21.4176H455.364V45.6714ZM433.726 43.1798H452.885V23.9225H433.726V43.1798Z"
					fill="#4C2A76"
				/>
				<path
					d="M453.255 21.809L431.618 43.5634L433.371 45.3249L455.008 23.5706L453.255 21.809Z"
					fill="#4C2A76"
				/>
				<path
					d="M433.364 21.7936L431.611 23.5554L453.251 45.3067L455.004 43.5448L433.364 21.7936Z"
					fill="#4C2A76"
				/>
				<path
					d="M433.726 45.6714H409.61V21.4176H433.726V45.6714ZM412.089 43.1798H431.247V23.9225H412.089V43.1798Z"
					fill="#4C2A76"
				/>
				<path
					d="M431.615 21.8043L409.978 43.5586L411.731 45.3202L433.368 23.5658L431.615 21.8043Z"
					fill="#4C2A76"
				/>
				<path
					d="M411.715 21.7979L409.962 23.5598L431.602 45.311L433.355 43.5492L411.715 21.7979Z"
					fill="#4C2A76"
				/>
				<path
					d="M412.089 45.6714H387.959V21.4176H412.089V45.6714ZM390.438 43.1798H409.597V23.9225H390.438V43.1798Z"
					fill="#4C2A76"
				/>
				<path
					d="M390.438 45.6714H366.322V21.4176H390.438V45.6714ZM368.8 43.1798H387.959V23.9225H368.8V43.1798Z"
					fill="#4C2A76"
				/>
				<path
					d="M388.316 21.7914L366.677 43.5427L368.429 45.3046L390.069 23.5533L388.316 21.7914Z"
					fill="#4C2A76"
				/>
				<path
					d="M368.428 21.7991L366.675 23.5609L388.315 45.3122L390.068 43.5503L368.428 21.7991Z"
					fill="#4C2A76"
				/>
				<path
					d="M368.801 45.6714H344.671V21.4176H368.801V45.6714ZM347.15 43.1798H366.308V23.9225H347.15V43.1798Z"
					fill="#4C2A76"
				/>
				<path
					d="M366.668 21.7958L345.028 43.5471L346.781 45.3089L368.421 23.5576L366.668 21.7958Z"
					fill="#4C2A76"
				/>
				<path
					d="M346.791 21.7974L345.038 23.5592L366.678 45.3105L368.431 43.5486L346.791 21.7974Z"
					fill="#4C2A76"
				/>
				<path
					d="M347.15 45.6714H323.033V21.4176H347.15V45.6714ZM325.512 43.1798H344.671V23.9225H325.512V43.1798V43.1798Z"
					fill="#4C2A76"
				/>
				<path
					d="M324.273 45.6714H302.635C302.134 45.6714 301.686 45.3666 301.488 44.9027C301.29 44.4388 301.409 43.8954 301.752 43.5508L323.389 21.8019L325.143 23.5646L305.615 43.193H323.745L345.027 21.8019L346.78 23.5646L325.143 45.3135C324.919 45.5389 324.602 45.6714 324.273 45.6714Z"
					fill="#4C2A76"
				/>
				<path
					d="M325.15 21.7909L323.397 23.5527L345.037 45.304L346.79 43.5422L325.15 21.7909Z"
					fill="#4C2A76"
				/>
				<path
					d="M412.669 244.261H387.867V220.007H412.669V244.261ZM390.425 241.769H410.124V222.512H390.425V241.769Z"
					fill="#4C2A76"
				/>
				<path
					d="M410.493 243.89L388.249 222.141L390.043 220.378L412.3 242.127L410.493 243.89Z"
					fill="#4C2A76"
				/>
				<path
					d="M390.043 243.89L388.249 242.127L410.493 220.378L412.3 222.141L390.043 243.89Z"
					fill="#4C2A76"
				/>
				<path
					d="M412.669 331.27H387.867V307.029H412.669V331.27ZM390.425 328.778H410.124V309.521H390.425V328.778Z"
					fill="#4C2A76"
				/>
				<path
					d="M410.493 330.912L388.249 309.15L390.043 307.4L412.3 329.149L410.493 330.912Z"
					fill="#4C2A76"
				/>
				<path
					d="M390.043 330.912L388.249 329.149L410.493 307.4L412.3 309.15L390.043 330.912Z"
					fill="#4C2A76"
				/>
				<path
					d="M412.669 263.956H387.867V239.715H412.669V263.956ZM390.425 261.464H410.124V242.207H390.425V261.464Z"
					fill="#4C2A76"
				/>
				<path
					d="M410.493 263.585L388.249 241.836L390.043 240.073L412.3 261.822L410.493 263.585Z"
					fill="#4C2A76"
				/>
				<path
					d="M390.043 263.585L388.249 261.822L410.493 240.073L412.3 241.836L390.043 263.585Z"
					fill="#4C2A76"
				/>
				<path
					d="M412.669 285.704H387.867V261.464H412.669V285.704ZM390.425 283.213H410.124V263.956H390.425V283.213Z"
					fill="#4C2A76"
				/>
				<path
					d="M410.493 285.347L388.249 263.584L390.043 261.822L412.3 283.571L410.493 285.347Z"
					fill="#4C2A76"
				/>
				<path
					d="M390.043 285.347L388.249 283.571L410.493 261.822L412.3 263.584L390.043 285.347Z"
					fill="#4C2A76"
				/>
				<path
					d="M412.669 307.453H387.867V283.213H412.669V307.453ZM390.425 304.962H410.124V285.705H390.425V304.962Z"
					fill="#4C2A76"
				/>
				<path
					d="M410.493 307.096L388.249 285.333L390.043 283.584L412.3 305.333L410.493 307.096Z"
					fill="#4C2A76"
				/>
				<path
					d="M390.043 307.096L388.249 305.333L410.493 283.584L412.3 285.333L390.043 307.096Z"
					fill="#4C2A76"
				/>
				<path
					d="M135.943 131.938C138.58 131.938 138.593 127.816 135.943 127.816C133.293 127.816 133.293 131.938 135.943 131.938Z"
					fill="#4C2A76"
					fill-opacity="0.65"
				/>
				<path
					d="M358.371 88.8776C361.008 88.8776 361.021 84.7558 358.371 84.7558C355.734 84.7558 355.734 88.8776 358.371 88.8776Z"
					fill="#4C2A76"
					fill-opacity="0.65"
				/>
				<path
					d="M450.445 236.402C450.749 236.402 451.052 236.402 451.355 236.402C452.423 236.402 453.452 235.447 453.412 234.334C453.359 233.221 452.516 232.267 451.355 232.267C451.052 232.267 450.749 232.267 450.445 232.267C449.377 232.267 448.349 233.221 448.388 234.334C448.454 235.461 449.298 236.402 450.445 236.402Z"
					fill="#4C2A76"
					fill-opacity="0.65"
				/>
				<path
					d="M54.7994 266.646C57.4365 266.646 57.4497 262.524 54.7994 262.524C52.1623 262.524 52.1623 266.646 54.7994 266.646Z"
					fill="#4C2A76"
					fill-opacity="0.65"
				/>
				<path
					d="M250.803 68.7191C253.44 68.7191 253.453 64.5973 250.803 64.5973C248.166 64.5973 248.166 68.7191 250.803 68.7191Z"
					fill="#4C2A76"
					fill-opacity="0.65"
				/>
			</svg>
			<div className="container">
				<p>Thank You for hopping on</p>
				<p>We would be going live on “Date”</p>
				<p>Until then, our latest collections are available on</p>
				<div
					style={{ marginTop: "20px", display: "flex", alignItems: "center" }}
				>
					<a
						style={{
							display: "flex",
							alignItems: "center",
							textDecoration: "none",
							color: "#FFB8BC"
						}}
						href="https://www.instagram.com/tina_rosario_the_design_house/?r=nametag"
					>
						<AiFillInstagram />
						<p style={{ marginLeft: "5px" }}>tina_rosario_the_design_house</p>
					</a>
				</div>
				<div
					style={{
						display: "flex",
						alignItems: "center",
						textDecoration: "none",
						color: "#FFB8BC"
					}}
				>
					<a
						style={{
							display: "flex",
							alignItems: "center",
							textDecoration: "none",
							color: "#FFB8BC"
						}}
						href="https://www.facebook.com/people/Tina-Rosario-The-Design-House/100086487516274/"
					>
						<AiFillFacebook />
						<p style={{ marginLeft: "5px" }}>Tina Rosario - The Design House</p>
					</a>
				</div>

				<p style={{ marginTop: "20px" }}>
					Stay tuned to start your online shopping spree.
				</p>
				<p>Or</p>
				<p>Walk into our local store located @</p>
				<p>112a Nehru street, Alwar thiru nagar, Chennai - 600087</p>
				<div
					style={{ marginTop: "20px", display: "flex", alignItems: "center" }}
				>
					<AiFillPhone />
					<p style={{ marginLeft: "5px" }}>+91 7200060540</p>
				</div>
				<div style={{ display: "flex", alignItems: "center" }}>
					<IoLogoWhatsapp />
					<p style={{ marginLeft: "5px" }}>+1 412-251-1363</p>
				</div>
			</div>
		</div>
	);
}

export default App;
